import request from '@/utils/request'
import { baseURL } from '@/utils/getawayModule'

/***
 *
 * 获取球场订单表列表 get
 * @param query 分页参数
 * @return request
 * */
export function getCourtOrderList(query) {
  return request({
    url: `${baseURL.businessApi}/orders/back/court/list`,
    method: 'get',
    params: query
  })
}

/**
 * 分页查询旅行订单列表(管理员)
 * @param query
 * @returns {AxiosPromise}
 */
export function getTravelOrderList(query) {
  return request({
    url: `${baseURL.businessApi}/orders/back/travel/list`,
    method: 'get',
    params: query
  })
}


/**
 * 分页查询商品订单列表(管理端)
 * @param query
 * @returns {AxiosPromise}
 */
export function selectBackOrderGoodsList(query) {
  return request({
    url: `${baseURL.businessApi}/orders/back/goods/list`,
    method: 'get',
    params: query
  })
}

/**
 * 分页查询商品订单列表(管理端)
 * @param query
 * @returns {AxiosPromise}
 */
export function getGoodsOrderList(query) {
  return request({
    url: `${baseURL.businessApi}/orders/user/back/goods/list`,
    method: 'get',
    params: query
  })
}

/**
 * 增加订单表 post
 * @param data 增加的数据
 * @return request
 * */
export function addOrder(data) {
  return request({
    url: `${baseURL.businessApi}/orders`,
    method: 'post',
    data: data
  })
}

/**
 * 删除订单表  delete
 * @param id 订单表id
 * @return request
 * */
export function deleteOrder(id) {
  return request({
    url: `${baseURL.businessApi}/orders/${id}`,
    method: 'delete'
  })
}

/***
 * 修改订单表 Post
 * @param id 要修改的订单表id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateOrder(id, data) {
  return request({
    url: `${baseURL.businessApi}/orders/${id}`,
    method: 'post',
    data: data
  })
}

export function getSaleOrderList(query) {
  return request({
    url: `${baseURL.businessApi}/orders/sale/list`,
    method: 'get',
    params: query
  })
}

export function updateOrderStatus(id, data) {
  return request({
    url: `${baseURL.businessApi}/orders/updateStatus/${id}`,
    method: 'post',
    data: data
  })
}

export function gameOrderStatus(id, data) {
  return request({
    url: `${baseURL.businessApi}/races/${id}`,
    method: 'post',
    data: data
  })
}

export function postPdfWrite(data) {
  return request({
    url: `${baseURL.businessApi}/pdf/write`,
    method: 'post',
    data: data
  })
}

/**
 * 修改订单
 * @param data
 * @param id
 * @returns {AxiosPromise}
 */
export function postOrderId(data, id) {
  return request({
    url: `${baseURL.businessApi}/orders/${id}`,
    method: 'post',
    data: data
  })
}

/**
 * 删除订单
 * @param id
 * @returns {AxiosPromise}
 */
export function deleteOrderById(id, orderType) {
  return request({
    url: `${baseURL.businessApi}/orders/${id}?orderType=${orderType}`,
    method: 'delete'
  })
}

/**
 * 修改订单球场
 * @param data
 * @param id
 * @returns {AxiosPromise}
 */
export function modifyStadiumOrderById(data, id) {
  return request({
    url: `${baseURL.businessApi}/order_courts/${id}`,
    method: 'post',
    data: data
  })
}

/**
 * 修改订单旅游
 * @param data
 * @param id
 * @returns {AxiosPromise}
 */
export function modifyTravelsOrderById(data, id) {
  return request({
    url: `${baseURL.businessApi}/order_travels/${id}`,
    method: 'post',
    data: data
  })
}

/**
 * 修改球场比赛
 * @param data
 * @param id
 * @returns {AxiosPromise}
 */
export function modifyRacesOrderById(data, id) {
  return request({
    url: `${baseURL.businessApi}/races/${id}`,
    method: 'post',
    data: data
  })
}


/**
 * 管理员修改球场订单
 * @param data
 * @param id
 * @returns {AxiosPromise}
 */
export function modifyOrderCourtsById(data, id) {
  return request({
    url: `${baseURL.businessApi}/order_courts/admin/${id}`,
    method: 'post',
    data: data
  })
}


/**
 * modifyOrderTravelsById
 * @param data
 * @param id
 * @returns {AxiosPromise}
 */
export function modifyOrderTravelsById(data, id) {
  return request({
    url: `${baseURL.businessApi}/order_travels/admin/${id}`,
    method: 'post',
    data: data
  })
}

/**
 * 修改球场比赛
 * @param data
 * @param id
 * @returns {AxiosPromise}
 */
export function modifyOrderRacesById(data, id) {
  return request({
    url: `${baseURL.businessApi}/races/${id}`,
    method: 'post',
    data: data
  })
}

/**
 * 分页查询取消订单
 * @param query
 * @returns {AxiosPromise}
 */
export function cancelOrders(query) {
  return request({
    url: `${baseURL.businessApi}/cancel_orders`,
    method: 'get',
    params: query
  })
}

/**
 * 根据订单ID查询最新的提交申请修改数据
 * @param id
 * @returns {AxiosPromise}
 */
export function cancelOrdersByOrderId(id) {
  return request({
    url: `${baseURL.businessApi}/cancel_orders/byOrderId/${id}`,
    method: 'get'
  })
}

/**
 * 更改取消订单状态
 * @param id
 * @param query
 * @returns {AxiosPromise}
 */
export function cancelOrdersStatusByOrderId(id, query) {
  return request({
    url: `${baseURL.businessApi}/cancel_orders/update/status/${id}`,
    method: 'post',
    params: query
  })
}

/**
 * 单独上传确认书
 * @param id 订单ID
 * @param data file
 * */
export function uploadBookByOrderId(id, data) {
  return request({
    url: `${baseURL.businessApi}/orders/upload/book/${id}`,
    method: 'post',
    data: data
  })
}
